const testItem = {
    imgURL: 'urlurl',
    title: 'Test title',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry...',
    linkURL: './#'
}

const defaultListItem = {
    imgURL: 'https://www.ubinam.de/news/news139165.jpg',
    title: 'Something went wrong',
    description: 'Can not load news content',
    linkURL: 'https://www.ubinam.de/remote-download/'
}

export {
    testItem,
    defaultListItem,

}

export default {
    testItem: testItem,
    defaultListItem: defaultListItem,

}